module.exports = __webpack_public_path__ + "assets/linkedin.5cd48f9c.svg";